import React, { useState } from 'react';
import { Modal, Upload, Button, message, Spin, Card, Descriptions } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { leerPDFOrden } from '../../services/entregas/servicesOrdenesCompra';

const { Dragger } = Upload;


const LeerPO = ({ modo = 'pdf', visible, onClose = () => { }, onIngresar = () => { } }) => {

    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState(null);

    const handleFileChange = ({ fileList: newFileList }) => {
        setFileList(newFileList.slice(-1));
    };

    const handleProcess = async () => {
        if (!fileList.length) return;
        setLoading(true);
        try {
            const realFile = fileList[0].originFileObj;
            const result = await leerPDFOrden(realFile);

            if (result.status === 200) {
                setSummary(result.data);
            } else {
                message.error(result.message || 'Error al procesar el PDF');
                setFileList([]);
            }
        } catch (err) {
            message.error('Error inesperado al procesar el PDF');
        } finally {
            setLoading(false);
        }
    };

    const handleIngresar = () => {
        // le pasamos summary **y** el file original
        onIngresar(summary, fileList[0].originFileObj);
        setSummary(null);
        setFileList([]);
    };

    const handleClose = () => {
        setSummary(null);
        setFileList([]);
        onClose();
    };

    return (
        <Modal
            open={visible}
            onCancel={handleClose}
            footer={null}
            width={600}
        >
            {modo === 'pdf' && !summary && (
                <>
                    <Dragger
                        disabled={loading}
                        multiple={false}
                        beforeUpload={() => false}
                        fileList={fileList}
                        onChange={handleFileChange}
                        accept=".pdf"
                        style={{ marginTop: 20, opacity: loading ? 0.6 : 1 }}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">
                            Haz clic o arrastra el archivo PDF aquí
                        </p>
                        <p className="ant-upload-hint">
                            Solo se admite un archivo en formato PDF.
                        </p>
                    </Dragger>
                    <div style={{ textAlign: 'right', marginTop: 16 }}>
                        <Spin spinning={loading}>
                            <Button
                                type="primary"
                                disabled={fileList.length === 0}
                                onClick={handleProcess}
                            >
                                Procesar
                            </Button>
                        </Spin>
                    </div>
                </>
            )}

            {summary && (
                <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <Card
                        title="Resumen de la Orden de Compra - PO"
                        style={{ marginTop: 20 }}
                    >
                        <Descriptions column={1} bordered size="small">
                            <Descriptions.Item label="Número de Orden">
                                {summary.ordenNumero}
                            </Descriptions.Item>
                            <Descriptions.Item label="Fecha PO">
                                {summary.fecha}
                            </Descriptions.Item>
                            <Descriptions.Item label="Proveedor">
                                {summary.proveedor}
                            </Descriptions.Item>
                            <Descriptions.Item label="Total PO">
                                {summary.totalPO}
                            </Descriptions.Item>
                            <Descriptions.Item label="Productos">
                                {Array.isArray(summary.lineas) ? summary.lineas.length : 0}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>

                    <div style={{ textAlign: 'left', marginTop: 10 }}>
                        <h5>Se recomienda realizar una revisión detallada de cada producto, sus valores y cantidades.</h5>
                    </div>
                    <div style={{ textAlign: 'right', marginTop: 16 }}>

                        <Button type="primary" onClick={handleIngresar}>
                            Ingresar PO
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default LeerPO;
